export function checkGuard(guards, authType) {
    const availableType = ["user"];
    if (!guards) guards = [];
    if (guards.length < 1) {
    // no guards, it's a public route
        return true;
    }

    if (!availableType.includes(authType)) {
        return "login";
    }

    return true;
}
